"use client";
import { TeamsProps } from "@/types/sections/teams";
import Image from "next/image";

export default function TeamsAvatarsSection({ data }: { data: TeamsProps }) {
  const { title, description, members, background } = data;

  const backgroundStyle =
    background?.type === "color"
      ? { backgroundColor: background.value }
      : background?.type === "gradient"
        ? { backgroundImage: background.value }
        : background?.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {};

  return (
    <section className="py-14 px-4" style={backgroundStyle}>
      <div className="max-w-6xl mx-auto text-center space-y-6">
        {title && <h2 className="text-3xl font-bold">{title}</h2>}
        {description && (
          <p className="text-muted-foreground max-w-xl mx-auto">
            {description}
          </p>
        )}

        <div className="flex flex-wrap justify-center gap-8 mt-8">
          {members.map((member, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center space-y-2 w-40"
            >
              {member.avatar && (
                <Image
                  src={member.avatar}
                  alt={member.name}
                  width={80}
                  height={80}
                  className="rounded-full object-cover border aspect-square object-center"
                />
              )}
              <div>
                <p className="font-medium">{member.name}</p>
                {member.role && (
                  <p className="text-sm text-muted-foreground">{member.role}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
